import type {CoreOrB2b} from './types';

import {envManager} from '../env';

/**
 * @param core - value for core env
 * @param b2b - value for b2b env
 * @returns value based on env
 */
export const pickCoreOrB2b = <C, B>({
  b2b,
  core,
}: CoreOrB2b<C, B>): B | C | undefined => {
  return envManager.isB2b ? b2b : core;
};
